import { styled, Tooltip, tooltipClasses } from "@mui/material";

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "#f05736",
    // boxShadow: theme.shadows[4],
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "Montserrat, sans-serif",
    letterSpacing: "0.05em",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white, // Background color for the arrow
    "&:before": {
      // boxShadow: theme.shadows[2], // Box shadow for the arrow
      boxShadow:
        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
    },
  },
}));
